import { useState } from "react";

const initialStatebox = {
  ejercicioinicio: 0,
  ejerciciofin: 0,
  periodoinicio: 0,
  periodofin: 0,
  ejercicio: new Date().getFullYear(),
  periodo: new Date().getMonth() + 1,
  filtrado: "",
  titulosucursal: "",
  titulodepartamento: "",
  responsable: 0,
  linea: 'C',
  cartera: 'C',
  convenio: 'CO',
  juridico: 'N',
  gestion: 'C',
  objecion: '999',
  rango: '0',
  arrayadr: [],
  arraysucursal: [],
  arraydepartamento: [],
  pv: { adr: [], sucursal: [], departamento: [] },
};
export const useBox = (initialState = initialStatebox) => {
  const [boxstate, setBoxState] = useState(initialState);

  const BoxChange = (name, value) => {
    setBoxState({
      ...boxstate,
      [name]: value,
    });
  };

  return [boxstate, BoxChange, setBoxState];
};

export const useBoxFiltros = (initialState = initialStatebox) => {
  const [boxstate, setBoxState] = useState(initialState);

  const BoxChange = (name, value) => {
    setBoxState({
      ...boxstate,
      [name]: value,
    });
  };

  return [boxstate, BoxChange];
};
